'use strict'

module.exports = blockquote

var wrap = require('../wrap')
var all = require('../all')

/* Transform a block quote. */
function blockquote(h, node) {
  return h(node, 'blockquote', wrap(all(h, node), true))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/blockquote.js
// module id = 886
// module chunks = 95715928098905 168707334958949